import { render, staticRenderFns } from "./CartPreviewRowNewEcommerce.vue?vue&type=template&id=820518fa&scoped=true&"
import script from "./CartPreviewRowNewEcommerce.vue?vue&type=script&lang=ts&"
export * from "./CartPreviewRowNewEcommerce.vue?vue&type=script&lang=ts&"
import style0 from "./CartPreviewRowNewEcommerce.vue?vue&type=style&index=0&id=820518fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820518fa",
  null
  
)

export default component.exports